import type { WithdrawBank } from '@mobile/screens/withdraw-banks/data'
import { AppIcon } from '@shared-ui/components/ui/app-icon'
import { FastImage } from '@shared-ui/components/ui/fast-image'
import { GText } from '@shared-ui/components/ui/text'
import { Pressable, View } from 'react-native'
import { useCreateStyles } from './styles'

type BankListProps = {
  banks: WithdrawBank[]
  onSelect: (bank: WithdrawBank) => void
}

type BankRowProps = {
  bank: WithdrawBank
  onPress: () => void
}

export function BankRow({ bank, onPress }: BankRowProps) {
  const styles = useCreateStyles()

  return (
    <Pressable style={styles.row} onPress={onPress}>
      <View style={styles.bankInfo}>
        <FastImage source={bank.image} style={styles.bankIcon} resizeMode="cover" />
        <GText fw={500} style={styles.bankName}>
          {bank.name}
        </GText>
      </View>
      <AppIcon icon="chevron-right" size={20} isSecondary />
    </Pressable>
  )
}

export function BankList({ banks, onSelect }: BankListProps) {
  const styles = useCreateStyles()

  return (
    <View style={styles.list}>
      {banks.map((bank, index) => (
        <BankRow key={`${bank.id}-${index}`} bank={bank} onPress={() => onSelect(bank)} />
      ))}
    </View>
  )
}
